import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PreferenceValue } from '../../../../../../api/types';

const usePreferenceValueOptions = () => {
    const { t } = useTranslation('moduleDetails');

    return useMemo(
        () => [
            {
                value: PreferenceValue.Yes,
                label: t('moduleDetails:explanations.preferenceValue.yes'),
            },
            {
                value: PreferenceValue.No,
                label: t('moduleDetails:explanations.preferenceValue.no'),
            },
            {
                value: PreferenceValue.Optional,
                label: t('moduleDetails:explanations.preferenceValue.optional'),
            },
        ],
        [t]
    );
};

export default usePreferenceValueOptions;
